package org.hs_soft.runmynesto.domain.model.home.statistic.tabs.abc_statics

import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

enum class ABCStatisticTableHeadersEnum(
    val title: String,
    val key: String,
    val isNumeric: Boolean,
) {
    CODE(
        title = LanguageManager.getCurrentStrings().code,
        key = "code",
        isNumeric = false
    ),
    NAME(
        title = LanguageManager.getCurrentStrings().name,
        key = "name",
        isNumeric = false
    ),
    SALES_GROUP(
        title = LanguageManager.getCurrentStrings().salesGroups,
        key = "salesGroup",
        isNumeric = false
    ),
    ANZAHL(
        title = LanguageManager.getCurrentStrings().number,
        key = "number",
        isNumeric = true
    ),
    AMOUNT(
        title = LanguageManager.getCurrentStrings().amount,
        key = "total",
        isNumeric = true
    ),
    WEIGHT(
        title = LanguageManager.getCurrentStrings().weight,
        key = "weight",
        isNumeric = true
    ),
    FIRST_SALE(
        title = LanguageManager.getCurrentStrings().firstSale,
        key = "firstSale",
        isNumeric = false
    ),
    LAST_SALE(
        title = LanguageManager.getCurrentStrings().lastSale,
        key = "lastSale",
        isNumeric = false
    )
}